import React from 'react';
import { useNavigate } from 'react-router-dom';

const SessionExpired = ({ onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    if (onClose) {
      onClose();
    }
    navigate('/');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '450px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          🔒
        </div>
        
        <h2 style={{
          margin: '0 0 16px 0',
          color: '#333',
          fontSize: '24px',
          fontWeight: '600'
        }}>
          Session Expired
        </h2>
        
        <p style={{
          margin: '0 0 30px 0',
          color: '#666',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          Your session has expired for security reasons. This may have happened because:
        </p>
        
        <ul style={{
          textAlign: 'left',
          color: '#666',
          fontSize: '14px',
          margin: '0 0 30px 0',
          paddingLeft: '20px'
        }}>
          <li style={{ marginBottom: '8px' }}>You've been inactive for too long</li>
          <li style={{ marginBottom: '8px' }}>You logged in from another device</li>
          <li style={{ marginBottom: '8px' }}>Your token has expired naturally</li>
        </ul>
        
        <button
          onClick={handleLogin}
          style={{
            backgroundColor: '#2980b9',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
            width: '100%'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#21618c'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#2980b9'}
        >
          Go to Login Page
        </button>
        
        <p style={{
          margin: '20px 0 0 0',
          color: '#999',
          fontSize: '12px'
        }}>
          Don't worry - your work is automatically saved
        </p>
      </div>
    </div>
  );
};

export default SessionExpired; 